import $ from 'jquery';

var pos = null;
var error = $(".cta-block__button-error");

if (error.length > 0) {
	pos = error.offset().top;
}

if (pos != null) {
	$("html,body").animate({scrollTop: pos + 120}, 1000);
}